const MyProfile = () =>
  import(/* webpackChunkName: "MyProfile" */ "@/components/ssp/MyProfile.vue");

export default [
  {
    path: "edit-profile",
    name: "edit-profile",
    component: MyProfile,
  },
];
